module.exports = __webpack_public_path__ + "static/media/darkBookmark.81a84884.svg";